import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    img: {
        height: theme.spacing(3.5),
        width: theme.spacing(5.5),
    },
}); });
export var BoxLogos = function (props) {
    var classes = useStyles();
    return props.logos ? (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", alignItems: "flex-start" }, props.logos.map(function (_a) {
            var url = _a.url, brand = _a.brand;
            return (React.createElement(Box, { key: brand + "_imageLogobox", id: brand, pr: 1.5, pb: 1 },
                React.createElement("img", { src: url, className: classes.img })));
        })))) : null;
};
